import laravelAxiosClient from "../laravelAxiosClient";
import {
  PeutAccederAuxWebinairesResult,
  WebinairesResult,
} from "../interfaces/webinaires.interface";

export const findAllWebinaires = async () => {
  const { data } = await laravelAxiosClient.get<WebinairesResult>("/webinaires");
  return data;
};

export const peutAccederAuxWebinaires = async () => {
  const { data } = await laravelAxiosClient.get<PeutAccederAuxWebinairesResult>(
    "/users/peut-acceder-aux-webinaires"
  );
  return data;
};
